export default __webpack_public_path__ + "static/media/Complience_Accordion.ccc1d8c8.svg";